import { view, layout } from "@/mega-ui/helpers/function"
import { activateOrderGuard } from "@/helpers/routerHelpers"

export const ordersExternal = {
    path: '/orders/activate',
    name: 'order-activate',
    component: () => layout('EmptyLayout'),
    children: [
        {
            path: '',
            name: 'order-activate-main',
            beforeEnter: [ activateOrderGuard ],
            meta: {
                withAuth: false
            },
            component: () => view('orders/ActivateSimCardView')
        },
    ]
}